import { IAccountChangeStatus, IChangeResult } from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class InHomeTrialSubscriptionToFamilyPlan implements IChangeFunction {
  public async validate(): Promise<IAccountChangeStatus> {
    return {
      fromStatus: 'ActiveSubscription',
      toStatus: 'FamilySubscription',
      success: true,
      message: 'Your personal free trial subscription has been stopped',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId?: string,
  ): Promise<IChangeResult> {
    if (!currentPlan.subscription) {
      throw new Error(`no subscription found for current plan ${currentPlan.id}`);
    }

    if (!familyPlanOwnerUserProfileId) {
      throw new Error('no family plan owner provided');
    }

    await paymentService.cancelSubscriptionImmediately(userProfile, currentPlan.subscription.id, currentPlan.id);
    await userProfileService.updateUserSubscriptionDetails(userProfile.uid);
    await userProfileService.addUserToFamilyPlan(userProfile.uid, familyPlanOwnerUserProfileId);

    return {
      marketingAnalyticsData: {
        trackingEventName: 'subscription_to_family',
      },
    };
  }
}
